import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/App";
import { Reveal } from "@/components/Section";

const IMG_VIVA = "https://prieure-saint-leonard.fr/api/files/prieure-saint-leonard/uploads/6e0cb8d6-d513-4ecb-b4b3-547347bf2e54.jpg";

const VivaArtist = () => {
  const { t } = useLang();
  const v = t.viva;
  return (
    <section data-testid="viva-artist-section" className="relative px-5 md:px-10 py-24 md:py-36 bg-moss overflow-hidden">
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="font-mono2 text-[10px] md:text-[11px] uppercase tracking-[0.3em] text-gold mb-5">{v.kicker}</p>
            <h2 data-testid="viva-title" className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-paper leading-[1.02] tracking-tight">
              {v.title}
            </h2>
            <p data-testid="viva-text" className="mt-8 text-paper/70 text-base md:text-lg leading-relaxed max-w-2xl">
              {v.text}
            </p>
            <div className="flex flex-wrap gap-2.5 mt-9" data-testid="viva-media">
              {v.media.map((m) => (
                <span key={m} className="border border-paper/25 text-paper/85 font-mono2 text-[10px] uppercase tracking-[0.2em] px-4 py-2">
                  {m}
                </span>
              ))}
            </div>
            <div className="mt-12 max-w-2xl">
              <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-gold/80 mb-5">{v.artistsTitle}</p>
              <div className="grid sm:grid-cols-2 gap-px bg-paper/15 border border-paper/15" data-testid="viva-artists">
                {v.artists.map((a, i) => (
                  <Link
                    key={i}
                    data-testid={`viva-artist-${i}`}
                    to={`/artiste/${a.slug}`}
                    className={`group bg-moss p-5 flex flex-col gap-1.5 hover:bg-[#35493a] transition-colors text-left${v.artists.length % 2 === 1 && i === v.artists.length - 1 ? " sm:col-span-2" : ""}`}
                  >
                    <span className="flex items-baseline justify-between gap-3">
                      <span className="font-display italic text-xl text-gold/70">{String(i + 1).padStart(2, "0")}</span>
                      <ArrowUpRight size={14} className="text-paper/30 group-hover:text-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                    </span>
                    <span className="font-display text-xl md:text-2xl text-paper leading-tight group-hover:text-gold transition-colors">{a.name}</span>
                    {a.detail && <span className="font-mono2 text-[10px] uppercase tracking-[0.15em] text-paper/45">{a.detail}</span>}
                  </Link>
                ))}
              </div>
            </div>
            <a
              data-testid="viva-link"
              href="https://www.viva-artist.com"
              target="_blank"
              rel="noreferrer"
              className="group inline-flex items-center gap-3 mt-11 bg-gold text-inkdeep hover:bg-paper transition-colors px-8 py-4 font-mono2 text-[11px] uppercase tracking-[0.2em]"
            >
              {v.cta}
              <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 border border-gold/40 translate-x-4 translate-y-4" />
              <div className="relative overflow-hidden aspect-[4/3] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.7)]">
                <img src={IMG_VIVA} alt="Concert VIVA ARTIST dans la chapelle du Prieuré" loading="lazy" className="w-full h-full object-cover img-lumiere hover:scale-[1.04] transition-transform duration-[1400ms] ease-out" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default VivaArtist;
